import React from 'react';
import { ErrorM } from './ErrorM';
import { Input } from './Input';

interface FormTextFieldProps<T> {
  field: string;
  label?: string;
  required: boolean;
  type?: string;
  hint?: string;
  optionalTag?: string;
  visible?: boolean;
  disabled?: boolean;
  placeholder?: string;
  labelPosition?: 'left' | 'top';
  value?: string;
  readOnly?: boolean;
}

const FormTextField = function <T>({
  field,
  label,
  required,
  type,
  hint,
  optionalTag,
  visible,
  disabled,
  placeholder,
  labelPosition,
  value,
  readOnly,
}: FormTextFieldProps<T>) {
  return (
    <div
      className={`FormBox FormSideBySide ${
        visible === false ? 'HideField' : ''
      } ${labelPosition ? labelPosition : ''}`}
    >
      <div className="FormLabel">
        {label && (
          <label>
            {label}{' '}
            {!required && <span className="Optional">- {optionalTag}</span>}
          </label>
        )}
        {hint && <div className="FormHint">{hint}</div>}
      </div>
      <div className="FormField">
        <Input
          name={field}
          type={type ? type : 'text'}
          disabled={disabled}
          placeholder={placeholder}
          value={value}
          readOnly={readOnly ?? false}
        />
        <ErrorM name={field} />
      </div>
    </div>
  );
};

export default FormTextField;
